import { PublicHeader } from '@/components/organisms/public-header'
import { SiteFooter } from '@/components/organisms/SiteFooter'
import { useEffect } from 'react'
import { AnimatedOutlet } from '@/components/ui/animated-outlet'
import { loadPageBeacon } from '@/lib/site-metrics'
import { usePublicThemeColor } from '@/hooks/usePublicThemeColor'
import { PageBeaconBoundary } from '@/components/marketing/PageBeaconBoundary'

export function PublicLayout() {
  // Cloudflare Web Analytics on the public pages only (lib/site-metrics.ts); the app never loads it.
  useEffect(() => loadPageBeacon(), [])
  usePublicThemeColor()
  return (
    <div className="chrome-on-dark dark h-full overflow-y-auto bg-[var(--surface-public)] text-[var(--text-public-primary)] flex flex-col">
      <PageBeaconBoundary />
      <PublicHeader />

      <main id="main-content" className="flex-1">
        <AnimatedOutlet />
      </main>

      <SiteFooter />
    </div>
  )
}
